module.exports = __webpack_public_path__ + "img/sidebar-logo.e4a25aac.svg";